import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ButtonBasic, InputDinamycPlaceholder } from "@lk-gtcom/ecomlab-components";
import './ModalСonfirmation.scss'
import { TextPage } from '../../../../components/TextPage/TextPage';

const ModalСonfirmation = ({
    setIsModal,
    onUploadFile,
    selectedFile,
    setSelectedFile
}) => {

    const onClose = () => {
        setIsModal(false)
        setSelectedFile(null)
    }

    return (
        <div className='blackout blackout-modal-2'
            style={{ zIndex: 12 }}
            onClick={(e) => {
                let el = e.target
                if (el.classList.contains('blackout-modal-2')) {
                    setIsModal(false)
                }
            }}>
            <div className='modal-add-task-exit'>
                <h1 className='modal-add-task-exit__title'>Выберите действие:
                </h1>
                <TextPage
                    text={<><span style={{ color: '#1890FF', fontWeight: 600 }}>Заменить: </span> удалить и заменить все значения на данные из файла</>}
                />
                <TextPage
                    text={<><span style={{ color: '#22C55E', fontWeight: 600 }}>Добавить: </span> обновить существующие и добавить новые значения из файла</>}
                />
                <div className='modal-add-task-exit__group-btn'>
                    <ButtonBasic
                        blue
                        text='Заменить'
                        width='100%'
                        onClick={(e) => {
                            onUploadFile(selectedFile, true)
                            onClose(false)
                        }}
                    />
                    <ButtonBasic
                        green
                        text='Добавить'
                        width='100%'
                        onClick={(e) => {
                            onUploadFile(selectedFile, false)
                            onClose(false)
                        }}
                    />
                    <ButtonBasic
                        red
                        text='Отмена'
                        width='100%'
                        onClick={(e) => {
                            onClose(false)
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export { ModalСonfirmation }